//@state
export interface CenterDesAvocatsState {}

export const initialState: CenterDesAvocatsState = {};
